import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height: number;
  width: number;
  color: string;
}

export const IconNotGoing = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.99998 12.2918C9.65831 12.2918 9.37498 12.0084 9.37498 11.6668V7.50011C9.37498 7.15845 9.65831 6.87511 9.99998 6.87511C10.3416 6.87511 10.625 7.15845 10.625 7.50011V11.6668C10.625 12.0084 10.3416 12.2918 9.99998 12.2918Z"
          fill={color}
        />
        <path
          d="M9.99998 15.0001C9.94998 15.0001 9.89165 14.9918 9.83331 14.9834C9.78331 14.9751 9.73331 14.9584 9.68331 14.9334C9.63331 14.9168 9.58331 14.8918 9.53331 14.8584C9.49165 14.8251 9.44998 14.7918 9.40831 14.7584C9.25831 14.6001 9.16665 14.3834 9.16665 14.1668C9.16665 13.9501 9.25831 13.7334 9.40831 13.5751C9.44998 13.5418 9.49165 13.5084 9.53331 13.4751C9.58331 13.4418 9.63331 13.4168 9.68331 13.4001C9.73331 13.3751 9.78331 13.3584 9.83331 13.3501C9.94165 13.3251 10.0583 13.3251 10.1583 13.3501C10.2166 13.3584 10.2666 13.3751 10.3166 13.4001C10.3666 13.4168 10.4166 13.4418 10.4666 13.4751C10.5083 13.5084 10.55 13.5418 10.5916 13.5751C10.7416 13.7334 10.8333 13.9501 10.8333 14.1668C10.8333 14.3834 10.7416 14.6001 10.5916 14.7584C10.55 14.7918 10.5083 14.8251 10.4666 14.8584C10.4166 14.8918 10.3666 14.9168 10.3166 14.9334C10.2666 14.9584 10.2166 14.9751 10.1583 14.9834C10.1083 14.9918 10.05 15.0001 9.99998 15.0001Z"
          fill={color}
        />
        <path
          d="M15.05 18.4668H4.94998C3.32498 18.4668 2.08331 17.8751 1.44998 16.8084C0.82498 15.7418 0.908313 14.3668 1.69998 12.9418L6.74998 3.85845C7.58331 2.35845 8.73331 1.53345 9.99998 1.53345C11.2666 1.53345 12.4166 2.35845 13.25 3.85845L18.3 12.9501C19.0916 14.3751 19.1833 15.7418 18.55 16.8168C17.9166 17.8751 16.675 18.4668 15.05 18.4668ZM9.99998 2.78345C9.21665 2.78345 8.44998 3.38345 7.84165 4.46678L2.79998 13.5584C2.23331 14.5751 2.14165 15.5084 2.53331 16.1834C2.92498 16.8584 3.79165 17.2251 4.95831 17.2251H15.0583C16.225 17.2251 17.0833 16.8584 17.4833 16.1834C17.8833 15.5084 17.7833 14.5834 17.2166 13.5584L12.1583 4.46678C11.55 3.38345 10.7833 2.78345 9.99998 2.78345Z"
          fill={color}
        />
      </svg>
    </SvgWrapper>
  );
};
